import React from 'react';
import { useLabels, usePrefs } from 'wsm-common-data';
import templates from '../templates';
import { promoPropTypes } from '../utilities/commonPropTypes';
import '../global-sass/index.scss';
import { isMobile4x3 } from '../utilities/aspect';
import { aR } from '../global-constants';
import { useURLPrefs } from '../hooks/useURLPrefs';

const IncentivePromo = ({
	aspectRatio,
	carouselPosition,
	ctaLabel,
	ctaUrl,
	globalVehicleId,
	id,
	imageUrl = null,
	incentive = {},
	isMobile,
	isVisible = true,
	promo,
	type,
	width
}) => {
	const {
		condition,
		description,
		disclaimer,
		error,
		offerDetails,
		shortTitle,
		title,
		trims,
		vehicleTrims
	} = incentive;

	const {
		showIncentiveTitleCondition,
		showIncentiveTitleBodystyle,
		useIncentiveShortTitle
	} = usePrefs();
	const { collection } = useURLPrefs();
	const labels = useLabels();

	// Ensure that we have a viable incentive
	if (
		globalVehicleId &&
		!error &&
		vehicleTrims &&
		vehicleTrims.length &&
		trims &&
		trims.length
	) {
		let trim;

		// Get the first vehicleTrimId in the list for the promo's globalVehicleId (incentive's vehicleTrims.vehicleId)
		const vehicleTrim = vehicleTrims.find(
			(val) => val.vehicleId === globalVehicleId
		);
		if (
			vehicleTrim &&
			vehicleTrim.vehicleTrimIds &&
			vehicleTrim.vehicleTrimIds.length
		) {
			const vehicleTrimId = vehicleTrim.vehicleTrimIds[0];
			if (vehicleTrimId) {
				// Get the trim information matching the vehicleTrimId
				trim = trims.reduce((acc, val) => {
					if (
						val.globalVehicleTrimIds &&
						val.globalVehicleTrimIds.includes(vehicleTrimId)
					) {
						return val;
					}
					return acc;
				}, null);
			}
		}

		if (trim) {
			const ctaButtonData = { ctaUrl, ctaLabel };
			const detailsButtonData = { id, type };

			// Give priority to incentive title or shortTitle, depending on preference
			let incentiveTitle = title || shortTitle;
			if (useIncentiveShortTitle === 'true') {
				incentiveTitle = shortTitle || title;
			}

			// Create vehicle description for the title
			let applicableVehicle =
				trim.year && trim.make && trim.model
					? `${trim.year} ${trim.make} ${trim.model}`
					: '';

			// Turn on additional title data with preferences
			if (showIncentiveTitleCondition === 'true') {
				applicableVehicle = `${labels.get(
					condition
				)} ${applicableVehicle}`;
			}
			if (showIncentiveTitleBodystyle === 'true') {
				applicableVehicle = `${applicableVehicle} ${trim.bodyStyle}`;
			}

			const isMobile4x3Template = isMobile4x3(aspectRatio);
			const updatedAR = isMobile4x3Template ? aR.MOBILE_4X3 : aspectRatio;

			const Template = templates[collection][updatedAR];
			if (Template) {
				return (
					<Template
						applicableVehicle={applicableVehicle}
						carouselPosition={carouselPosition}
						ctaButtonData={ctaButtonData}
						description={description}
						detailsButtonData={detailsButtonData}
						disclaimer={disclaimer}
						imageUrl={imageUrl}
						incentive={incentive}
						isMobile={isMobile}
						isVisible={isVisible}
						offerDetails={offerDetails}
						promo={promo}
						title={incentiveTitle}
						type={type}
						width={width}
					/>
				);
			}
		}
	}
	return null;
};

IncentivePromo.propTypes = promoPropTypes;

export default IncentivePromo;
